import { useCallback } from 'react';
import { useTrackEventMutation } from 'app/data/mutations/use-track-event-mutation';
import { WebPageImpressionProperties, WebPageImpressionTrackEvent } from 'app/data/types/tracking';

export const useTrackPageImpression = (): ((properties: WebPageImpressionProperties) => void) => {
  const { trackEvent } = useTrackEventMutation();

  return useCallback(
    (properties: WebPageImpressionProperties) => {
      const event: WebPageImpressionTrackEvent = {
        type: 'impression',
        event_type: 'track_v2_web_page_impression',
        properties,
      };

      trackEvent(event);
    },
    [trackEvent],
  );
};
